import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CHAT_STRINGS_PT, ChatStrings } from '../../chat.strings';
import { ChatMessageProperty } from '../../chat.model';
import { ChatIconName } from '../chat-icon/chat-icon.component';
import { formatPrice } from '../../chat.format';

/** Uma linha de factos do cartão (tipologia, wc, área). */
interface PropertyFact {
  icon: ChatIconName;
  text: string;
}

/**
 * `kind: 'property'` (contrato 6.2, v3): foto com pills de tipo de negócio e
 * estado, referência, preço (ou "sob consulta"), título, localização, uma
 * linha de factos (T3 · 2 WC · 120 m²) e as ações "Ver detalhes" e, com
 * `canScheduleVisit`, "Agendar visita" (emite o imóvel; o contentor abre o
 * modal). `property.route` (comandos do router) ganha a `property.link`.
 */
@Component({
  selector: 'chat-property-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './chat-property-card.component.html',
  styleUrls: ['./chat-property-card.component.css']
})
export class ChatPropertyCardComponent implements OnChanges {
  @Input() property!: ChatMessageProperty;
  @Input() canScheduleVisit = false;
  @Input() strings: ChatStrings = CHAT_STRINGS_PT;
  @Output() scheduleVisit = new EventEmitter<ChatMessageProperty>();

  imageFailed = false;
  price = '';
  businessTypeText = '';
  statusText = '';
  statusTone: 'ok' | 'warn' | 'off' = 'ok';
  facts: PropertyFact[] = [];

  ngOnChanges(): void {
    const p = this.property || ({} as ChatMessageProperty);
    this.price = formatPrice(p.price, p.businessType === 'rent');
    this.businessTypeText = p.businessType === 'rent' ? this.strings.forRent : p.businessType === 'sale' ? this.strings.forSale : '';
    const code = p.businessStatus && p.businessStatus.code ? String(p.businessStatus.code).toUpperCase() : '';
    this.statusText = (code && this.strings.propertyStatus[code]) || (p.businessStatus && p.businessStatus.name) || '';
    this.statusTone = code === 'AVAILABLE' ? 'ok' : code === 'RESERVED' ? 'warn' : code ? 'off' : 'ok';
    const facts: PropertyFact[] = [];
    if (p.bedrooms !== undefined && p.bedrooms !== null) {
      facts.push({ icon: 'bed', text: 'T' + p.bedrooms });
    }
    if (p.bathrooms) {
      facts.push({ icon: 'home', text: this.strings.bathroomsShort.replace('{n}', String(p.bathrooms)) });
    }
    const area = p.usefulArea || p.grossArea;
    if (area) {
      facts.push({ icon: 'area', text: Math.round(area) + ' m²' });
    }
    this.facts = facts;
  }
}
